import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { App, Card, Col, Row } from 'antd';

import { isEmpty, isString } from 'lodash';

import { SmsServiceType } from '../../../shared/constants/enums';
import * as sharedActions from '../../../shared/store/actions';
import { AppDispatch, RootState } from '../../../store';
import { SelectedNewChatItemEvent, UnreadCountData } from '../models';
import * as actions from '../store/actions';
import ChatList from './chat-list';
import ChatMessagesArea from './chat-messages-area';
import SmsMessagesHeader from './sms-messages-header';

import './styles.less';
import { CheckerForSmsUser } from '../../../shared/models';

const SmsMessages = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { modal } = App.useApp();

  const didMount = useRef(false);

  const [newUnreadCount, setNewUnreadCount] = useState<UnreadCountData | undefined>();
  const [selectedNewChatItem, setSelectedNewChatItem] = useState<SelectedNewChatItemEvent>({ isNew: true });

  const { messageControlParameters, hasUpdateLoading } = useSelector((state: RootState) => state.smses);
  const messageFromChecker = useSelector((state: RootState) => state.webSocket.smsMessage);

  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      dispatch(actions.getSmsSetting());
    }
  }, []);

  useEffect(() => {
    if (messageControlParameters) {
      dispatch(
        sharedActions.sendMessage({
          isSms: true,
          currentUserId: messageControlParameters.userId,
          agencyId: messageControlParameters.agencyId,
          agencyUserId: messageControlParameters.ownerAccountUserId,
          isAgencySmsService:
            messageControlParameters.smsServiceType === SmsServiceType.AgencyOwnRingCentral ||
            messageControlParameters.smsServiceType === SmsServiceType.AgencyTwilio ||
            messageControlParameters.smsServiceType === SmsServiceType.AgencySpoke ||
            messageControlParameters.smsServiceType === SmsServiceType.AgencyGlobalTelecom,
          isGroupAccount: messageControlParameters.smsServiceType === SmsServiceType.PhoneGroup,
          phoneGroupPhoneNumber: messageControlParameters.myNumber,
        } as CheckerForSmsUser),
      );

      if (isString(messageControlParameters.errorMessage) && !isEmpty(messageControlParameters.errorMessage)) {
        modal.error({
          title: messageControlParameters.errorMessage,
        });

        dispatch(actions.clearMessageControlError());
      }

      if (isString(messageControlParameters.messageToInform) && !isEmpty(messageControlParameters.messageToInform)) {
        modal.error({
          title: messageControlParameters.messageToInform,
        });

        dispatch(actions.clearMessageToInform());
      }
    }
  }, [messageControlParameters, messageControlParameters?.smsServiceType]);

  useEffect(() => {
    if (!hasUpdateLoading && messageFromChecker && messageFromChecker.isSms === true) {
      if (messageFromChecker.hasSmsUpdates === true) {
        dispatch(actions.getUpdatesSuccess({ chat: true, message: true }));
      }
    }
  }, [messageFromChecker]);

  const updateMessageControl = () => {
    setSelectedNewChatItem({ ...selectedNewChatItem });
  };

  return (
    <>
      <Card title={<SmsMessagesHeader updateMessageControl={updateMessageControl} />} className="smses">
        <Row className="smses-main-row">
          <Col flex="none">
            <Card className="card-with-chat-list" styles={{ body: { display: 'flex', flexDirection: 'column' } }}>
              <ChatList newUnreadCount={newUnreadCount} updateMessageControl={updateMessageControl} />
            </Card>
          </Col>
          <Col flex="auto">
            <Card className="card-with-chat-messages" styles={{ body: { display: 'flex', flexDirection: 'column' } }}>
              <ChatMessagesArea
                setNewUnreadCount={setNewUnreadCount}
                selectedNewChatItem={selectedNewChatItem}
                updateMessageControl={updateMessageControl}
              />
            </Card>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default SmsMessages;
